import { render, staticRenderFns } from "./COrderTransferModal.vue?vue&type=template&id=ebc6231c&scoped=true"
import script from "./COrderTransferModal.vue?vue&type=script&lang=ts"
export * from "./COrderTransferModal.vue?vue&type=script&lang=ts"
import style0 from "./COrderTransferModal.vue?vue&type=style&index=0&id=ebc6231c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc6231c",
  null
  
)

export default component.exports